import LayoutContentArea from "@/components/layout/LayoutContentArea";
import AnomaliesSection from "@/components/site-administration/AnomaliesSection";

export default function AnomaliesPage() {
  return (
    <LayoutContentArea headingText="Anomalies">
      <p
        style={{
          color: "#000",
          marginTop: "-1rem",
          marginBottom: "1.5rem",
          maxWidth: "900px",
        }}
      >
        Activate or deactivate anomaly processes for the entire site.
      </p>
      <AnomaliesSection />
    </LayoutContentArea>
  );
}
